// extracted by mini-css-extract-plugin
export var category = "OverviewMinimal-module--category--Qz-e5";
export var container = "OverviewMinimal-module--container--t8slp";
export var gatsbyLink = "OverviewMinimal-module--gatsbyLink--ayP8f";
export var linkDateContainer = "OverviewMinimal-module--linkDateContainer--K19Nz";
export var title = "OverviewMinimal-module--title--mB4Dd";